import View from '../../../view.js';

namespace('IO.Views.Components.Rje', function (exports) {
  'use strict';

  var ConfigurationAPI = IO.Views.Components.Rje.Api.Configuration,
    Codes = IO.Views.Components.Rje.Codes,
    Configuration = View.extend({
      dom: {
        APPLY_OPTION: '.apply-option',
        DROPDOWN_OPTION: '.option',
        DROPDOWN_LABEL: '.dropdown-label',
        STATUS_OPTION: '.status-option',
        SUMMARY_OPTION: '.summary-option',
        VALIDATE_OPTION: '.validate-option',
      },

      events: function () {
        var events = {};

        events['click ' + this.dom.APPLY_OPTION] = '_apply';
        events['click ' + this.dom.VALIDATE_OPTION] = '_validate';
        events['click ' + this.dom.STATUS_OPTION] = '_status';
        events['click ' + this.dom.SUMMARY_OPTION] = '_summary';
        return events;
      },

      /*
        PUBLIC FUNCTIONS
      */
      initialize: function (options) {
        this.configurationApi = new ConfigurationAPI({
          csrf: options.csrf,
        });
        this.name = options.name;
        this.poll = options.poll;
        this._attachEvents();
      },

      destroy: function () {
        this.stopListening();
        this.off();
      },

      getStatusURL: function () {
        return this.$el.data('state');
      },

      setManagementState: function (enabled) {
        if (enabled) {
          this.$(this.dom.DROPDOWN_OPTION).removeClass('disabled');
        } else {
          this.$(this.dom.DROPDOWN_OPTION).addClass('disabled');
        }
      },

      /*
        PRIVATE FUNCTIONS
      */
      _attachEvents: function () {
        this.listenTo(
          this.configurationApi,
          'apply:success',
          this._applySuccessCallback,
        );
        this.listenTo(
          this.configurationApi,
          'apply:fail',
          this._applyFailCallback,
        );
        this.listenTo(
          this.configurationApi,
          'validate:success',
          this._validateSuccessCallback,
        );
        this.listenTo(
          this.configurationApi,
          'validate:fail',
          this._validateFailCallback,
        );
        // this.listenTo(this.configurationApi, 'status:online', this._statusSuccessCallback)
        // this.listenTo(this.configurationApi, 'status:unknown', this._statusFailCallback)
        this.listenTo(
          this.configurationApi,
          'summary:success',
          this._summarySuccessCallback,
        );
        this.listenTo(
          this.configurationApi,
          'summary:fail',
          this._summaryFailCallback,
        );

        // this.listenTo(this.configurationApi, 'state:enabled', this._setEnabled)
        // this.listenTo(this.configurationApi, 'state:disabled', this._setDisabled)
        // this.listenTo(this.configurationApi, 'state:unknown', this._setUnknown)

        this.listenTo(this.poll, 'error', this._setUnknown);
        this.listenTo(this.poll, 'virtuals', this._processVirtuals); // virtual
        // node
        this.listenTo(this.poll, this.name + ':puppet', this._setPuppetState);
        this.listenTo(
          this.poll,
          this.name + ':status',
          this._setPuppetStateByStatus,
        );
      },

      _processVirtuals: function (virtuals) {
        var virtual = virtuals[this.name];

        if (this.name === 'node') {
          return;
        }

        if (virtual) {
          this._setPuppetState(virtual.puppet);
          this._setPuppetStateByStatus(virtual.state);
        } else {
          this._setUnknown();
        }
      },

      _alert: function (args) {
        // TODO check if options.alert is true
        // TODO '.content' will become options.alertTarget
        if (this.alert) {
          this.alert.close();
        }
        this.alert = new Alert(args);
        this.alert.prependTo('#main-content').show();
      },

      // apply
      _apply: function (e) {
        var target = e.currentTarget,
          url = target.href,
          $applyOption = this.$(this.dom.APPLY_OPTION);

        if ($(target).closest('.disabled').length) {
          return false;
        }

        this._setDropdownLabel('applying');
        $applyOption.text('Applying...');
        $applyOption.parent().addClass('disabled');
        this.configurationApi.apply(url);
        return false;
      },

      _applySuccessCallback: function (response) {
        this._alert({
          message: response.data.message || 'Configuration is being applied...',
          type: 'success',
        });
        this.isApplying = true;
      },

      _applyFailCallback: function (response) {
        this._error(response.statusmsg);
        this._setDropdownLabel();
        this.$(this.dom.APPLY_OPTION)
          .text('Apply')
          .parent()
          .removeClass('disabled');
      },

      // validate
      _validate: function (e) {
        var target = e.currentTarget,
          url = target.href,
          $validateOption = this.$(this.dom.VALIDATE_OPTION);

        if ($(target).closest('.disabled').length) {
          return false;
        }

        this._setDropdownLabel('validating');
        $validateOption.text('Validating...');
        $validateOption.parent().addClass('disabled');
        this.configurationApi.validate(url);
        return false;
      },

      _validateSuccessCallback: function () {
        this._alert({
          message: 'Configuration is being validated...',
          type: 'success',
        });
        this.isValidating = true;
      },

      _validateFailCallback: function (response) {
        this._error(response.statusmsg);
        this._setDropdownLabel();
        this.$(this.dom.VALIDATE_OPTION)
          .text('Dry-Run')
          .parent()
          .removeClass('disabled');
      },

      _summary: function (e) {
        var target = e.currentTarget,
          url = target.href,
          $summaryOption = this.$(this.dom.SUMMARY_OPTION);

        if ($(target).closest('.disabled').length) {
          return false;
        }

        $summaryOption.text('Fetching...');
        $summaryOption.parent().addClass('option disabled');
        this.configurationApi.summary(url);
        return false;
      },

      _summarySuccessCallback: function (response) {
        this._setLabelSummary();
        this.$('.show-dropdown').removeClass('show-dropdown');

        this.trigger('summary', response.data);
      },

      _summaryFailCallback: function (response) {
        this._error(response.statusmsg);
        this._setLabelSummary();
        console.log('summary fail...', response); // eslint-disable-line no-console
      },

      _setLabelSummary: function () {
        var $summaryOption = this.$(this.dom.SUMMARY_OPTION);

        $summaryOption.text('Last run result');
        $summaryOption.parent().removeClass('option disabled');
      },

      _setDataStatus: function (action) {
        switch (action) {
          case 'applying a catalog':
            this._setDropdownLabel('applying');
            break;
          case 'stopped':
            this._setDropdownLabel();
            this._restoreLabels();
            if (this.isApplying || this.isValidating) {
              this.$(this.dom.SUMMARY_OPTION).trigger('click');
            }
            this.isValidating = false;
            this.isApplying = false;
            break;
          default:
            break;
        }
      },

      _restoreLabels: function () {
        this.$(this.dom.VALIDATE_OPTION).text('Dry-Run');
        this.$(this.dom.APPLY_OPTION).text('Apply');
      },

      _setDropdownLabel: function (option) {
        switch (option) {
          case 'applying':
            this.$(this.dom.DROPDOWN_LABEL).text(
              'Configuration is being applied...',
            );
            this.$(this.dom.DROPDOWN_OPTION).addClass('disabled');
            break;
          case 'validating':
            this.$(this.dom.DROPDOWN_LABEL).text(
              'Configuration is being validated...',
            );
            this.$(this.dom.DROPDOWN_OPTION).addClass('disabled');
            break;
          default:
            this.$(this.dom.DROPDOWN_LABEL).text('Configuration');
            this.$(this.dom.DROPDOWN_OPTION).removeClass('disabled');
            break;
        }
      },

      _setDisabled: function () {
        this.setManagementState(false);
      },

      _setEnabled: function (resp) {
        if (!resp.isApplying && this.status === 'online') {
          this.setManagementState(true);
        }
      },

      _setUnknown: function () {
        this._setDisabled();
      },

      _setPuppetState: function (state) {
        this.puppetState = state;
      },

      _setPuppetStateByStatus: function (status) {
        if (status === Codes.STATE_RUNNING || status === 'online') {
          switch (this.puppetState) {
            case Codes.PUPPET_DISABLED:
              this._setDisabled();
              break;
            case Codes.PUPPET_ENABLED_STOPPED:
              this._setEnabled({ isApplying: false });
              this._setDataStatus('stopped');
              break;
            case Codes.PUPPET_ENABLED_RUNNING:
              this._setEnabled({ isApplying: true });
              this._setDataStatus('applying a catalog');
              break;
            default:
              this._setUnknown();
              break;
          }
        } else {
          this._setUnknown();
        }
      },

      _triggerStatusquo: function (resp) {
        this.trigger('statusquo', resp);
      },

      _error: function (msg) {
        this._alert({
          message: msg || 'An error occurred. Please contact support.',
          type: 'alert',
        });
      },
    });

  exports.Configuration = Configuration;
});
